export const LOAD_NOTES_SUCCESS = 'LOAD_NOTES_SUCCESS'
export const NEW_NOTE = 'NEW_NOTE'
export const DELETE_NOTE = 'DELETE_NOTE'
